import { Pipe, PipeTransform } from '@angular/core';
import { BuildingEmergencyContactDto } from '@artemis-software/wr-api';
import TypeEnum = BuildingEmergencyContactDto.TypeEnum;

export const emergencyContactTypeTranslations: Record<TypeEnum, string> = {
  WATER_DAMAGE: 'Wasserschaden',
  HEATING_FAILURE: 'Heizungsausfall',
  STORM_DAMAGE: 'Sturmschaden',
};

@Pipe({
  standalone: false,
  name: 'emergencyContactTypeTranslation',
})
export class EmergencyContactTypeTranslationPipe implements PipeTransform {
  transform(value?: TypeEnum): string | undefined {
    return value ? emergencyContactTypeTranslations[value] : undefined;
  }
}
